import React, { useEffect } from 'react';

const InRoomDiningAllergenViewDetail = ({ allergen }) => {
  useEffect(() => {}, [allergen]);

  return (
    <div className='row mx-4 mt-4'>
      {
        <>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Allergen Name</div>
            <div className='details-value preview-breaks'>{allergen.name}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label text-center'>Status</div>
            <div
              className={`${
                allergen.status ? 'pill-active' : 'pill-inactive'
              } col-md-3 pill-text pill container`}
            >
              <span>{allergen.status ? 'Active' : 'Inactive'}</span>
            </div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Allergen Code</div>
            <div className='details-value'>{allergen.code}</div>
          </div>
          {allergen?.customAttributes &&
            allergen?.customAttributes?.length > 0 &&
            allergen?.customAttributes?.map((item, index) => (
              <div key={index} className='col-md-6 mt-4'>
                <div className='details-label'>{item.key}</div>
                <div className='details-value'>{item.value}</div>
              </div>
            ))}
        </>
      }
    </div>
  );
};

export default InRoomDiningAllergenViewDetail;
